const ACCOUNT_LIST_GRID = 'ACCOUNT_LIST_GRID';

const ACCOUNT_SUB_LIST_GRID = 'ACCOUNT_SUB_LIST_GRID';

export {
  ACCOUNT_LIST_GRID,
  ACCOUNT_SUB_LIST_GRID
}